var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C6.17478 0 2.70855 2.106 0.15448 5.52C-0.0514933 5.802 -0.0514933 6.192 0.15448 6.474C2.70855 9.894 6.17478 12 10 12C13.8252 12 17.2915 9.894 19.8455 6.48C20.0515 6.198 20.0515 5.808 19.8455 5.526C17.2915 2.106 13.8252 0 10 0ZM10.2766 10.224C7.74018 10.386 5.64514 8.28 5.80403 5.724C5.9335 3.618 7.63425 1.908 9.72929 1.776C12.2657 1.614 14.3607 3.72 14.2019 6.276C14.0665 8.382 12.3657 10.092 10.2766 10.224ZM10.1471 8.274C8.78182 8.358 7.65191 7.23 7.74018 5.85C7.8108 4.716 8.72885 3.798 9.85876 3.72C11.2241 3.636 12.354 4.764 12.2657 6.144C12.1892 7.284 11.2711 8.202 10.1471 8.274Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.370c91e4106805e4a02170198b139a15.svg";
export { ForwardRef as ReactComponent };